class UserAuth {

    constructor(userId, userType, userName, authkeyType, token, tokenExpirationDate, clientName, clientId) {
        this.userId = userId;
        this.userType = userType;
        this.userName = userName;
        this.authkeyType = authkeyType;
        this.token = token;
        this.tokenExpirationDate = tokenExpirationDate;
        this.clientName = clientName;
        this.clientId = clientId;
    }
}

export default UserAuth;